import React, { useState } from 'react';
import { Modal, Input, Select, Upload, Button, message, Form } from 'antd';
import { UploadOutlined, FilePdfOutlined } from '@ant-design/icons';

const { TextArea } = Input;
const { Option } = Select;

const CreatePDFModal = ({ show, onClose, onCreate, newPDF, setNewPDF, submitting, categories }) => {
  const [fileList, setFileList] = useState([]);

  const handleUpload = (file) => {
    // Check if file is PDF
    if (file.type !== 'application/pdf') {
      message.error('Please upload a PDF file only');
      return false;
    }
    
    setFileList([file]);
    setNewPDF({ ...newPDF, file: file });
    return false; // Prevent automatic upload
  };

  const handleSubmit = () => {
    if (!newPDF.title || !newPDF.description || !newPDF.category || !newPDF.file) {
      message.error('Please fill out all fields and select a PDF file');
      return;
    }
    onCreate();
  };

  const handleClose = () => {
    setFileList([]);
    onClose();
  };

  return (
    <Modal
      title={
        <div>
          <FilePdfOutlined style={{ marginRight: 8 }} />
          Upload New PDF Resource
        </div>
      }
      visible={show}
      onCancel={handleClose}
      onOk={handleSubmit}
      okText="Upload"
      cancelText="Cancel"
      confirmLoading={submitting}
      width={600}
    >
      <Form layout="vertical">
        <Form.Item label="Title" required>
          <Input
            placeholder="Enter PDF title"
            value={newPDF.title}
            onChange={(e) => setNewPDF({ ...newPDF, title: e.target.value })}
          />
        </Form.Item>

        <Form.Item label="Description" required>
          <TextArea
            placeholder="Enter PDF description"
            value={newPDF.description}
            onChange={(e) => setNewPDF({ ...newPDF, description: e.target.value })}
            rows={4}
          />
        </Form.Item>

        <Form.Item label="Category" required>
          <Select
            placeholder="Select category"
            value={newPDF.category}
            onChange={(value) => setNewPDF({ ...newPDF, category: value })}
          >
            {categories.map(cat => (
              <Option key={cat.value} value={cat.value}>
                {cat.label}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item label="PDF File" required>
          <Upload
            beforeUpload={handleUpload}
            fileList={fileList}
            onRemove={() => {
              setFileList([]);
              setNewPDF({ ...newPDF, file: null });
            }}
            accept=".pdf"
          >
            <Button icon={<UploadOutlined />}>Select PDF File</Button>
          </Upload>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreatePDFModal; 